<template>
  <v-autocomplete
    v-model="address"
    :items="addressesList"
    :loading="loadingAddresses"
    :search-input.sync="searchAddress"
    :filter="() => true"
    :clearable="true"
    return-object
    hide-no-data
    hide-details
    placeholder="Saisissez une adresse"
  />
</template>

<script>
import eventBus from '../assets/event-bus.js'
import { mapState } from 'vuex'
import axios from 'axios'
const debounce = require('debounce')

export default {
  data: () => ({
    addressesList: [],
    searchAddress: '',
    loadingAddresses: false,
    address: null
  }),
  computed: {
    ...mapState(['dataset'])
  },
  watch: {
    searchAddress: debounce(async function () {
      this.loadingAddresses = true
      if (!this.searchAddress || this.searchAddress.length < 3) {
        this.addressesList = this.address ? [this.address] : []
      } else {
        const params = {
          q: this.searchAddress
        }
        const result = (await axios.get('https://data.geopf.fr/geocodage/search/', { params })).data
        this.addressesList = result.features.map(f => ({ text: f.properties.label, value: f.geometry.coordinates.reverse().concat(f.properties.type) }))
      }
      this.loadingAddresses = false
    }, 300),
    address (addr) {
      if (addr) {
        eventBus.$emit('goTo', addr.value)
      }
    }
  }
}
</script>
